var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"kst-status",class:_vm.theClass,attrs:{"type":"is-flex is-size-6 py-1 ks-is-fullwidth kst-status"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }